export type SeoLanguage = "pt-BR" | "en-US" | "pt-PT";

const BASE_URL_BY_LANGUAGE: Record<SeoLanguage, string> = {
  "pt-BR": "https://cartacanalizada.com.br",
  "en-US": "https://channeledletter.com",
  // Portugal: pode ser sobrescrito no deploy sem mexer no código.
  "pt-PT":
    process.env.NEXT_PUBLIC_BASE_URL_PT_PT || "https://pt.cartacanalizada.com.br",
};

export function getBaseUrlByLanguage(lang: string): string {
  if (lang === "en-US") return BASE_URL_BY_LANGUAGE["en-US"];
  if (lang === "pt-PT") return BASE_URL_BY_LANGUAGE["pt-PT"];
  return BASE_URL_BY_LANGUAGE["pt-BR"];
}

export function getAllBaseUrls() {
  return BASE_URL_BY_LANGUAGE;
}
